import { useCssHandles } from '../../../../utils/functions';

const CSS_HANDLES = ['totalProducts', 'totalProductsMessage'];
const Content = () => {
	const { handles, withModifiers }: any = useCssHandles('vtex-search-result-3-x-', CSS_HANDLES);
	const totalProductsClasses = withModifiers('totalProducts', 'layout');

	return (
		<div className={`${totalProductsClasses} pv5 ph9 bn-ns bt-s b--muted-5 tc-s tl t-action--small`}>
			<span>
				2 <span className={`${handles.totalProductsMessage} c-muted-2`}>Produtos</span>
			</span>
		</div>
	);
};
export default Content;
